export default __webpack_public_path__ + "static/media/favicon.5e5dd3a0.png";